// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.foundBook {
    border:2px solid rgb(0, 102, 255);
    margin:4px;
    box-sizing: border-box;
    border-radius:20px;
    background-color:rgb(250, 250, 250);
    position:relative;
    padding:10px;
}

.bookImage {
    display:block;
    float:none;
    box-sizing: border-box;
    width:100%;
    padding:10px;
    margin:auto;
    text-align: center;
}

.bookImage img {
    width:60%;
    max-width:160px;
    box-shadow:4px 4px 12px gray;
    margin:auto;
}

.bookInfo {
   
    display: block;
    float:none;
    box-sizing: border-box;
    width:100%;
    padding:10px;
}

.bookInfo h2 {
    font-size:26px;
    font-weight: 700;
    letter-spacing: -.01em;
    margin:0;
    margin-top:18px;
}
.bookInfo h3 {
    font-size:22px;
    margin:0;
    margin-top:12px;
    color:gray;
}

.bookInfo h4 {
    font-size:20px;
    margin:0;
    margin-top:8px;
    color:gray;
    font-weight: 600;
}
.bookInfo p {
    color:#555555;
    font-size:16px;
    line-height: 24px;
    padding-right:24px;
    padding-bottom:4px;
    margin:0;
}



.ebookLink {
    display: inline-block;
    background-color: #1a7f37;
    color: white;
    text-decoration: none;
    border-radius: 30px;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 700;
    margin-right: 20px;
    margin-bottom: 8px;
}

.ebookLink:hover {
    background-color: #22a048;
    color: white;
}

.bookButton {
    border:none;
    border-radius:30px;
    background-color:rgb(0, 59, 147);
    color:white;
    text-transform:uppercase;
    box-sizing: border-box;
    padding:12px;
    font-size:16px;
    font-weight: 600;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    min-width:120px;
    margin-top:0;
    cursor: pointer;
    margin-right:20px;
    /* box-shadow:0 0 8px rgb(4, 26, 97); */
}

.bookButton:hover {
    background-color:rgb(40, 109, 212);
    

}

.save {
    background-color:rgb(79, 171, 192);
    transition:all .5s;
}

.save:hover {
    background-color:rgb(12, 182, 201);
}

.save:active, .save:focus {
    background-color:rgb(15, 80, 87);
}

.saved {
    background-color:gray;
}

.savedBookCloser {
    position: absolute;
    top:16px;
    right:16px;
    color:gray;
    -webkit-user-select: none;
            user-select: none;
    cursor:pointer;
    font-size:34px;
    font-weight: 600;
}

.savedBookCloser:hover {
    color:black;
}

@media only screen and (min-width: 800px) {

    .bookImage {
       
        display:inline-block;
        float:left;
        box-sizing: border-box;
        width:30%;
        padding:10px;
        text-align: center;
    }
    
    .bookImage img {
        width:80%;
        margin:auto;
    }
    
    .bookInfo {
     
        display:inline-block;
        float:left;
        box-sizing: border-box;
        width:70%;
        padding:10px;
    }
    

}`, "",{"version":3,"sources":["webpack://./src/components/BookCard.css"],"names":[],"mappings":";;AAEA;IACI,iCAAiC;IACjC,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,4BAA4B;IAC5B,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,UAAU;IACV,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,cAAc;IACd,QAAQ;IACR,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;AACZ;;;;AAIA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,wBAAwB;IACxB,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,kCAAkC;;;AAGtC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI;;QAEI,oBAAoB;QACpB,UAAU;QACV,sBAAsB;QACtB,SAAS;QACT,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;;QAEI,oBAAoB;QACpB,UAAU;QACV,sBAAsB;QACtB,SAAS;QACT,YAAY;IAChB;;;AAGJ","sourcesContent":["\n\n.foundBook {\n    border:2px solid rgb(0, 102, 255);\n    margin:4px;\n    box-sizing: border-box;\n    border-radius:20px;\n    background-color:rgb(250, 250, 250);\n    position:relative;\n    padding:10px;\n}\n\n.bookImage {\n    display:block;\n    float:none;\n    box-sizing: border-box;\n    width:100%;\n    padding:10px;\n    margin:auto;\n    text-align: center;\n}\n\n.bookImage img {\n    width:60%;\n    max-width:160px;\n    box-shadow:4px 4px 12px gray;\n    margin:auto;\n}\n\n.bookInfo {\n   \n    display: block;\n    float:none;\n    box-sizing: border-box;\n    width:100%;\n    padding:10px;\n}\n\n.bookInfo h2 {\n    font-size:26px;\n    font-weight: 700;\n    letter-spacing: -.01em;\n    margin:0;\n    margin-top:18px;\n}\n.bookInfo h3 {\n    font-size:22px;\n    margin:0;\n    margin-top:12px;\n    color:gray;\n}\n\n.bookInfo h4 {\n    font-size:20px;\n    margin:0;\n    margin-top:8px;\n    color:gray;\n    font-weight: 600;\n}\n.bookInfo p {\n    color:#555555;\n    font-size:16px;\n    line-height: 24px;\n    padding-right:24px;\n    padding-bottom:4px;\n    margin:0;\n}\n\n\n\n.ebookLink {\n    display: inline-block;\n    background-color: #1a7f37;\n    color: white;\n    text-decoration: none;\n    border-radius: 30px;\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: 700;\n    margin-right: 20px;\n    margin-bottom: 8px;\n}\n\n.ebookLink:hover {\n    background-color: #22a048;\n    color: white;\n}\n\n.bookButton {\n    border:none;\n    border-radius:30px;\n    background-color:rgb(0, 59, 147);\n    color:white;\n    text-transform:uppercase;\n    box-sizing: border-box;\n    padding:12px;\n    font-size:16px;\n    font-weight: 600;\n    user-select: none;\n    cursor: pointer;\n    min-width:120px;\n    margin-top:0;\n    cursor: pointer;\n    margin-right:20px;\n    /* box-shadow:0 0 8px rgb(4, 26, 97); */\n}\n\n.bookButton:hover {\n    background-color:rgb(40, 109, 212);\n    \n\n}\n\n.save {\n    background-color:rgb(79, 171, 192);\n    transition:all .5s;\n}\n\n.save:hover {\n    background-color:rgb(12, 182, 201);\n}\n\n.save:active, .save:focus {\n    background-color:rgb(15, 80, 87);\n}\n\n.saved {\n    background-color:gray;\n}\n\n.savedBookCloser {\n    position: absolute;\n    top:16px;\n    right:16px;\n    color:gray;\n    user-select: none;\n    cursor:pointer;\n    font-size:34px;\n    font-weight: 600;\n}\n\n.savedBookCloser:hover {\n    color:black;\n}\n\n@media only screen and (min-width: 800px) {\n\n    .bookImage {\n       \n        display:inline-block;\n        float:left;\n        box-sizing: border-box;\n        width:30%;\n        padding:10px;\n        text-align: center;\n    }\n    \n    .bookImage img {\n        width:80%;\n        margin:auto;\n    }\n    \n    .bookInfo {\n     \n        display:inline-block;\n        float:left;\n        box-sizing: border-box;\n        width:70%;\n        padding:10px;\n    }\n    \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
